export const STUDENT_COMPETENCY_STATUS = {
  NOT_STARTED: 'NotStarted',
  STARTED: 'Started',
  TO_BE_APPROVED: 'ToBeApproved',
  NOT_APPROVED: 'NotApproved',
  RETURNED: 'Returned',
  TO_BE_SIGNED: 'ToBeSigned',
  ACQUIRED: 'Acquired',
  SENT_OUT: 'SentOut',
  SENDING_ERROR: 'SendingError'
};